import api from './api';
import toast from 'react-hot-toast';

const BASE = '/api/reports';

// ── Blob download helper ──────────────────────────────────────────────────────

async function blobDownload(url, params) {
  const response = await api.get(url, { params, responseType: 'blob' });

  const disposition = response.headers['content-disposition'] || '';
  const match       = disposition.match(/filename="?([^";\n]+)"?/i);
  const ext         = (params.format === 'csv') ? '.csv' : '.pdf';
  const filename    = match ? match[1] : `trainaxis-report${ext}`;

  const objectUrl = URL.createObjectURL(new Blob([response.data]));
  const link      = document.createElement('a');
  link.href       = objectUrl;
  link.download   = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(objectUrl);
}

async function safeDownload(url, params, loadingSetter) {
  if (loadingSetter) loadingSetter(true);
  try {
    await blobDownload(url, params);
  } catch (err) {
    // When server returns error as blob, parse it back to JSON
    if (err.response?.data instanceof Blob) {
      try {
        const text = await err.response.data.text();
        const json = JSON.parse(text);
        toast.error(json.message || 'Download failed');
        return;
      } catch { /* fall through */ }
    }
    const msg = err.response?.data?.message || 'Download failed. Please try again.';
    toast.error(msg);
    throw err;
  } finally {
    if (loadingSetter) loadingSetter(false);
  }
}

// ── Expense Export ────────────────────────────────────────────────────────────
// params: { format, startDate, endDate, status, category, paymentMethod }

export const downloadExpenseReport = (params, loadingSetter) =>
  safeDownload(`${BASE}/expenses/export`, params, loadingSetter);

// ── Student List Export ───────────────────────────────────────────────────────
// params: { format }

export const downloadStudentListReport = (params, loadingSetter) =>
  safeDownload(`${BASE}/students/export`, params, loadingSetter);

// ── Single Student Profile Export ────────────────────────────────────────────
// Always PDF

export const downloadStudentProfile = (studentId, loadingSetter) =>
  safeDownload(`${BASE}/students/${studentId}/export`, { format: 'pdf' }, loadingSetter);

// ── Business Transaction Ledger Export (Stage 4) ─────────────────────────────────
// params: { format, start, end, account, category, direction, search } — same range + filters
// the on-screen ledger table is currently using, so the download matches what's visible.

export const downloadLedgerReport = (params, loadingSetter) =>
  safeDownload(`${BASE}/ledger/export`, params, loadingSetter);
